import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { AmenityDtoSchema } from '../contracts';

const UpdateAmenitiesRequestDtoSchema = z.object({
  facilityId: z.number(),
  items: z.array(
    z.object({
      amenityId: z.number(),
      isSelected: z.boolean(),
    })
  ),
});

const UpdateAmenitiesResponseDtoSchema = z.array(
  z.object({
    category: z.object({ id: z.number(), name: z.string() }),
    amenities: z.array(AmenityDtoSchema),
  })
);

export type UpdateAmenitiesRequestDto = z.infer<
  typeof UpdateAmenitiesRequestDtoSchema
>;
export type UpdateAmenitiesResponseDto = z.infer<
  typeof UpdateAmenitiesResponseDtoSchema
>;

export const updateAmenities = (
  dto: UpdateAmenitiesRequestDto,
  config?: AxiosRequestConfig<UpdateAmenitiesRequestDto['items']>
) => {
  const { facilityId, items } = UpdateAmenitiesRequestDtoSchema.parse(dto);
  return api
    .patch(`/amenities/facility/${facilityId}/amenities`, items, config)
    .then(responseContract(UpdateAmenitiesResponseDtoSchema));
};
